import lodash from 'lodash';
import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs } from 'common/util/queryHelper';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { loadBinderUsers } from 'binder/actions/';
import { binderInstitutionIdSelector } from 'common/selectors';

export const ADD_EXTERNAL_USER = 'ADD_EXTERNAL_USER';
export const LOAD_EXTERNAL_USERS = 'LOAD_EXTERNAL_USERS';
export const LOAD_EXTERNAL_USER = 'LOAD_EXTERNAL_USER';
export const WAITING_FOR_LOAD_EXTERNAL_USER = 'WAITING_FOR_LOAD_EXTERNAL_USER';
export const WAITING_FOR_LOAD_EXTERNAL_USERS = 'WAITING_FOR_LOAD_EXTERNAL_USERS';
export const REMOVE_EXTERNAL_USER = 'REMOVE_EXTERNAL_USER';
export const CLEAR_EXTERNAL_USER = 'CLEAR_EXTERNAL_USER';
export const SET_EXISTING_USER = 'SET_EXISTING_USER';

export function resendRegistrationEmail(user, binderId) {
    const query = toMutation(nodeWithArgs('resetExternalUser', {
        id: user.id,
        binderId: binderId,
    }));

    return dispatch => {
        return queryGraphQL(query).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', lodash.map(response.errors, 'message')));
            } else {
                dispatch(addApplicationMessages('success', ['The user has been sent a new registration email.']));
            }
        });
    };
}

export function sendNotificationEmail(userId, binderId, institutionId, startDate, endDate) {
    const query = toMutation(nodeWithArgs('sendNotificationExternalUser', {
        userId,
        binderId,
        institutionId,
        startDate,
        endDate,
    }));

    return dispatch => {
        return queryGraphQL(query).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', lodash.map(response.errors, 'message')));
            } else {
                dispatch(addApplicationMessages('success', ['The user has been sent a notification email.']));
            }
        });
    };
}

export function removeExternalUser(user, binderId, institutionId) {
    return (dispatch, getState) => {
        const permissions = JSON.stringify({
            [user.sub]: {
                hasBinderAccess: 'no'
            }
        });
        const query = nodeWithArgs('updateExternalUserBinderPermissions', {
            userPermissions: {
                binderId,
                permissions,
                institutionId,
            }
        }, [
            'id',
        ]);

        return mutateGraphQL(toMutation(query)).then(results => {
            if (results.errors) {
                dispatch(addApplicationMessage('error', 'An error occurred when removing the external user'));
                return;
            }
            dispatch({
                type: REMOVE_EXTERNAL_USER,
                payload: results.data.updateExternalUserBinderPermissions,
            });
            dispatch(addApplicationMessage('success', 'User removed from binder'));
            dispatch(loadBinderUsers(binderId, institutionId));
        });
    };
}

export function addExternalUser(user, binderId, institutionId, startDate, endDate) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('addExternalUserToBinder', {
            binderId,
            institutionId,
            startDate,
            endDate,
            user,
        }, [
            'startDate',
            'endDate',
        ]);

        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add external user.'));
            } else {
                dispatch({
                    type: ADD_EXTERNAL_USER,
                    payload: results.data.addExternalUserToBinder,
                });

                dispatch({ type: CLEAR_EXTERNAL_USER });
                dispatch(addApplicationMessage('success', 'External user added.'));
                dispatch(loadBinderUsers(binderId));
                dispatch(loadExternalUsers(binderId, institutionId));
            }
        });
    };
}

export function loadExternalUsers(binderId, institutionId, searchOptions) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('externalUsers', {
            institutionId,
            binderId,
            ...searchOptions,
        }, [
            'id',
            'sub',
            'institutionId',
            'emailAddress',
            'firstName',
            'lastName',
            'displayName',
            nodeWithArgs('binderExpiration', {
                binderId
            }, [
                'startDate',
                'endDate',
            ]),
        ]);

        dispatch(waitingForLoadExternalUsers(true));

        return queryGraphQL(toQuery(query)).then(results => {
            dispatch({
                type: LOAD_EXTERNAL_USERS,
                payload: results.data.externalUsers,
            });

            dispatch(waitingForLoadExternalUsers(false));
        });
    };
}

export function loadExternalUser(emailAddress) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs('loadUserByEmail', {
            emailAddress,
            institutionId,
        }, [
            'id',
            'sub',
            'emailAddress',
            'firstName',
            'lastName',
            'displayName',
        ]);

        dispatch(waitingForLoadExternalUser(true));

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Error occurred while searching for user'));
            } else {

                let user = results.data.loadUserByEmail;
                if (!user) {
                    user = {
                        emailAddress,
                    };
                }

                dispatch({
                    type: LOAD_EXTERNAL_USER,
                    payload: user,
                });
            }

            dispatch(waitingForLoadExternalUser(false));
        });
    };
}

export function waitingForLoadExternalUser(status) {
    return {
        type: WAITING_FOR_LOAD_EXTERNAL_USER,
        payload: status,
    };
}

export function waitingForLoadExternalUsers(status) {
    return {
        type: WAITING_FOR_LOAD_EXTERNAL_USERS,
        payload: status,
    };
}

export function clearExternalUser() {
    return {
        type: CLEAR_EXTERNAL_USER,
    };
}

export function setExistingUser(user) {
    return {
        type: SET_EXISTING_USER,
        payload: user
    };
}
